export const PETERSBURG_U3_SLUG = 'unit-3-e43a85'
export const GIBSON_U1_SLUG = 'unit-1-c53151'
